export function isSameDay(date1: Date, date2: Date): boolean {
  return Math.abs(date1.getTime() - date2.getTime()) < 24 * 60 * 60 * 10000
}

export function toJavaConvertableDateString(date: Date): string {
  //Removes the trailing 'Z' from the ISO string to make it compatible with Java's LocalDateTime parser
  return date.toISOString().slice(0, -1)
}

export function formatDateRange(startIso: string, endIso: string) {
  const start = new Date(startIso)
  const end = new Date(endIso)

  const shortFmt = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: 'short',
  })

  const fullFmt = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })

  if (start.getFullYear() === end.getFullYear()) {
    return `${shortFmt.format(start)}–${fullFmt.format(end)}`
  }
  return `${fullFmt.format(start)} – ${fullFmt.format(end)}`
}
